import { Injectable, NgZone } from "@angular/core";
import { Subject, BehaviorSubject, Observable, fromEvent } from "rxjs";
import { map } from "rxjs/operators";
import { AppState } from "./app.service";
import { SpinnerService } from "./spinner.service";
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { SocialSharing } from '@awesome-cordova-plugins/social-sharing/ngx';
import { Platform } from "@ionic/angular";
declare const navigator: any;

function _window(): any {
  // return the global native browser window object
  return window;
}

@Injectable()
export class CordovaService {
  private resume: BehaviorSubject<boolean>;
  IsVideoViewedSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
  inAppBrowserRef;
  constructor(private zone: NgZone, private appState: AppState, private spinnerService: SpinnerService,
    private inAppBrowser: InAppBrowser,
  private transfer: FileTransfer,
    private file: File,
    private platform: Platform,
    private socialSharing: SocialSharing) {
    this.resume = new BehaviorSubject<boolean>(null);
    fromEvent(document, "resume").subscribe((event) => {
      this.zone.run(() => {
        this.onResume();
      });
    });


  }
  get videoViewedStatus() {
    return this.IsVideoViewedSubject.asObservable();
  }
  setVideoViewedStatus(val) {
    this.IsVideoViewedSubject.next(val);
  }
  get cordova(): any {
    return _window().cordova;
  }

  public setNameToGA(screenName: String) {
    if (this.cordova) {
      console.log("In a GA cordova ");

      try {
        console.log("Completed a GA cordova 1");
        _window().cordova.ga.trackView(screenName);
      } catch (error) { }

      console.log("Completed a GA cordova ");
    }
  }

  get onCordova(): boolean {
    return !!_window().cordova;
  }

  public hideSplashScreen() {
    if (this.onCordova && navigator && navigator.splashscreen) {
      navigator.splashscreen.hide();
    }
  }

  public isIOS(): boolean {
    return this.onCordova && this.cordova.platformId === "ios";
  }

  public isAndroid(): boolean {
    return this.onCordova && this.cordova.platformId === "android";
  }

  public returnPlatform() {
    if (this.onCordova) {
      return this.cordova.platform;
    } else {
      return "Null platform";
    }
  }

  public onResume(): void {
    this.resume.next(true);
  }

  public openMail(url: string) {
    if (this.onCordova)
      this.inAppBrowser.create(url, "_system", "hidden=yes,location=yes");
  }

  public openBrowserLinkVideo(url: string,compName?) {
    var path = this.appState.get("currentPath");

    try {
      if (path.enabledAttributes?.secure_links) {
        console.log("openBrowserLinkVideo secure_links true");
        console.log(
          "openBrowserLinkVideo Includes",
          url.includes("1st90-api-images")
        );

        if (this.cordova && url.includes("1st90-api-images")) {
          this.InAppBrowserVideoSystem(url,compName);
        } else {
           this.inAppBrowser.create(url, "_system");
            if (compName == 'isOnboarding') {
            // setTimeout(() => {
            //   this.setVideoViewedStatus(true);
              // },2500)
             document.addEventListener('pause', this.onAppPauseForPlayingVideo.bind(this), false);
          }       
        }
      } else {
        console.log("openBrowserLinkVideo secure_links false");
        this.InAppBrowserVideoSystem(url,compName);
      }
    } catch (error) {
      console.log("openBrowserLinkVideo secure_links ", error);
      this.InAppBrowserVideoSystem(url,compName);
    }
  }
  onAppPauseForPlayingVideo() {
    setTimeout(() => {
       this.setVideoViewedStatus(true);
    },500)
  }
  public openLinkInBrowser(url: string) {
    var path = this.appState.get("currentPath");

    console.log("Path cordova url", url);

    try {
      if (path.enabledAttributes?.secure_links) {
        console.log("secure_links true");
        console.log("Includes", url.includes("1st90-api-images"));

        if (this.cordova && url.includes("1st90-api-images")) {
          this.InAppBrowserLinks(url);
        } else {
          this.inAppBrowser.create(url, "_system");
        }
      } else {
        console.log("secure_links false");
        this.InAppBrowserLinks(url);
      }
    } catch (error) {
      console.log("secure_links ", error);
      this.InAppBrowserLinks(url);
    }
  }

  InAppBrowserLinks(url) {
    if (this.cordova && this.cordova.platformId === "android") {
      if (url.match('.pdf')) {
        try {
        const urlLink = encodeURIComponent(url);
        this.inAppBrowserRef = this.cordova.InAppBrowser.open('https://docs.google.com/viewer?embedded=true&url=' + urlLink);
        this.injectPdfDownloadButtonAndroid(this.inAppBrowserRef, url);
        }
        catch(e) {
         console.log("error",e)
        }
     } 
    else if (/mp4$/.test(url)) {
        this.inAppBrowser.create(url, "_system");
      } else {
        this.inAppBrowser.create(url, "_blank", "location=yes");
      }
    } else if (this.cordova && this.cordova.platformId === "ios") {
      const browser = this.inAppBrowser.create(
        url,
        "_blank",
        "location=no,footer=yes,footercolor=#CC000000,closebuttoncaption=Done,closebuttoncolor=#2196f3,toolbarposition=top,lefttoright=yes"
      );
      if (url.match('.pdf')) {
        this.injectPdfDownloadButtoniOS(browser, url);
      }
    } else if (this.cordova) {
      this.inAppBrowser.create(url, "_blank", "location=yes");
    }
  }

  private injectPdfDownloadButtonAndroid(browser: any, originalUrl: string) {
    // message event: button posts directly to native — no URL navigation, no "unknown scheme" error
    browser.addEventListener('message', (params: any) => {
      if (params.data && params.data.action === 'download') {
        this.downloadAndShare(params.data.url);
      }
    });

    browser.addEventListener('loadstop', () => {
      browser.executeScript({
        code: `
          (function() {
            if (document.getElementById('iab-pdf-download-btn')) return;
            var url = ${JSON.stringify(originalUrl)};
            var btn = document.createElement('button');
            btn.id = 'iab-pdf-download-btn';
            btn.style.cssText = [
              'position:fixed', 'bottom:5vh', 'right:2vh',
              'z-index:2147483647', 'background:#2196f3', 'color:#fff',
              'padding:15px 16px', 'border-radius:24px', 'font-size:14px',
              'font-weight:500', 'border:none', 'cursor:pointer',
              'box-shadow:0 2px 8px rgba(0,0,0,0.35)',
              'display:inline-flex', 'align-items:center', 'gap:6px'
            ].join(';');
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>Download';
            btn.addEventListener('click', function() {
              window.webkit.messageHandlers.cordova_iab.postMessage(
                JSON.stringify({ action: 'download', url: url })
              );
            });
            document.body.appendChild(btn);
          })();
        `
      });
    });
  }

  private injectPdfDownloadButtoniOS(browser: any, originalUrl: string) {
    const DOWNLOAD_SCHEME = 'iab-pdf-dl';

    // Intercept the custom scheme and download the file natively
    const loadStartSub = browser.on('loadstart').subscribe((event: any) => {
      if (event.url && event.url.startsWith(DOWNLOAD_SCHEME + '://')) {
        const pdfUrl = decodeURIComponent(event.url.replace(DOWNLOAD_SCHEME + '://', ''));
        this.downloadAndShare(pdfUrl);
      }
    });

    const loadStopSub = browser.on('loadstop').subscribe(() => {
      browser.executeScript({
        code: `
          (function() {
            if (document.getElementById('iab-pdf-download-btn')) return;
            var url = ${JSON.stringify(originalUrl)};
            var scheme = ${JSON.stringify(DOWNLOAD_SCHEME)};
            var btn = document.createElement('button');
            btn.id = 'iab-pdf-download-btn';
            btn.style.cssText = [
              'position:fixed', 'bottom:5vh', 'right:2vh',
              'z-index:2147483647', 'background:#2196f3', 'color:#fff',
              'padding:10px 16px', 'border-radius:24px', 'font-size:14px',
              'font-weight:500', 'border:none', 'cursor:pointer',
              'box-shadow:0 2px 8px rgba(0,0,0,0.35)',
              'display:inline-flex', 'align-items:center', 'gap:6px'
            ].join(';');
            btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>Download';
            btn.addEventListener('click', function() {
              window.location.href = scheme + '://' + encodeURIComponent(url);
            });
            document.body.appendChild(btn);
          })();
        `
      });
    });

    browser.on('exit').subscribe(() => {
      loadStartSub.unsubscribe();
      loadStopSub.unsubscribe();
    });
  }

  private downloadAndShare(url) {
    const name =url.substr(url.lastIndexOf("/") + 1);
    const fileName = name.split('?')[0] || 'document.pdf';
    const savePath = this.file.dataDirectory + fileName;
     const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fileName;
    const plainTitle = tempDiv.textContent || tempDiv.innerText || '';
    if (this.platform.is('mobileweb')) {
      // For mobile browser: open in new tab or use Web Share API if available
      if (navigator.share) {
        navigator.share({
          title: plainTitle,
          url: url,
        }).catch((error) => {
          console.log('Web Share failed:', error);
        });
      }
    } else {
          const transfer = this.transfer.create();
      transfer.download(url, this.file.dataDirectory + fileName).then((entry) => {
          this.file.resolveLocalFilesystemUrl(entry.toURL()).then((fileEntry: any) => {
            let localPath = fileEntry.nativeURL;
            console.log('new file path: ', localPath);
            if (localPath) {
              this.socialSharing.share("", "", localPath, "")
              .then((entries) => {
                console.log('success ' + JSON.stringify(entries));
              })
              .catch((error) => {
                console.log('error ' + JSON.stringify(error));
              });
            }
          }).catch((error) => {
            console.log('download failed: ', error);
          });      
        })
    }
  }



  InAppBrowserVideoSystem(url: string,compName?) {
    if (this.cordova && this.cordova.platformId === "android") {
      let openBrowser = this.inAppBrowser.create(
        url,
        "_blank",
        "location=yes,enableViewportScale=false"
      );
      if (compName == 'isOnboarding') {
         this.setVideoViewedStatus(true);
         //document.addEventListener('pause', this.onAppPauseForPlayingVideo.bind(this), false);
      }
      openBrowser.on('exit').subscribe(event => {
        // your action here when close inAppBrowser
        console.log("inAppBrowser is closed now");
        openBrowser.close();
      });
    } else if (this.cordova && this.cordova.platformId === "ios") {
      let openBrowser = this.inAppBrowser.create(
        url,
        "_blank",
        "location=no,footer=yes,footercolor=#CC000000,closebuttoncaption=Done,closebuttoncolor=#2196f3,toolbarposition=top,lefttoright=yes"
      );
      if (compName == 'isOnboarding') {
         this.setVideoViewedStatus(true);
         //document.addEventListener('pause', this.onAppPauseForPlayingVideo.bind(this), false);
      }
      openBrowser.on('exit').subscribe(event => {
        // your action here when close inAppBrowser
        console.log("inAppBrowser is closed now");
        openBrowser.close();
      });
    } else {
      this.inAppBrowser.create(
        url,
        "_blank",
        "location=yes,enableViewportScale=true"
     );
      if (compName == 'isOnboarding') {
        this.setVideoViewedStatus(true);
         //document.addEventListener('pause', this.onAppPauseForPlayingVideo.bind(this), false);
      }
    }
  }
}
